<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5" v-if="requisicaoDetalhe">
                            Processo:
                            <strong>{{ requisicaoDetalhe.processo }}</strong>
                            <b-button
                                variant="danger"
                                @click.stop="voltar()"
                                class="float-right btn-sm"
                            >
                                <span>
                                    <i class="fa fa-history"></i> Voltar à lista
                                    de serviços
                                </span>
                            </b-button>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <div v-if="requisicaoDetalhe">
                            <h5 class="heading-1 mb-4">
                                <span>DADOS DA REQUISIÇÃO</span>
                            </h5>
                            <app-k-v
                                titulo="Data Requisição"
                                :md="3"
                                :lg="2"
                                :xl="1"
                                ><strong>{{
                                    $moment(
                                        requisicaoDetalhe.dataRequisicao
                                    ).format('DD/MM/YYYY')
                                }}</strong></app-k-v
                            >
                            <app-k-v
                                titulo="Data Necessidade"
                                :md="3"
                                :lg="2"
                                :xl="1"
                                ><strong>{{
                                    $moment(
                                        requisicaoDetalhe.dataNecessidade
                                    ).format('DD/MM/YYYY')
                                }}</strong></app-k-v
                            >
                            <app-k-v
                                titulo="Objeto"
                                :md="3"
                                :lg="2"
                                :xl="1"
                                :dado="requisicaoDetalhe.objeto"
                            ></app-k-v>
                            <app-k-v
                                titulo="Texto Complementar"
                                :md="3"
                                :lg="2"
                                :xl="1"
                                :dado="requisicaoDetalhe.textoComplementar"
                            ></app-k-v>
                            <app-k-v
                                titulo="Solicitante"
                                :md="3"
                                :lg="2"
                                :xl="1"
                                ><strong
                                    >{{ requisicaoDetalhe.solicitante }} -
                                    {{
                                        requisicaoDetalhe.contatoSolicitante
                                    }}</strong
                                ></app-k-v
                            >

                            <app-k-v titulo="Valor" :md="3" :lg="2" :xl="1"
                                ><strong>{{
                                    requisicaoDetalhe.valor | currency
                                }}</strong></app-k-v
                            >
                            <app-k-v titulo="Situação" :md="3" :lg="2" :xl="1"
                                ><app-status
                                    :status="requisicaoDetalhe.situacao"
                                ></app-status
                            ></app-k-v>
                        </div>
                        <requisicao-itens
                            :requisicao="requisicaoDetalhe"
                        ></requisicao-itens>
                        <requisicao-comprometimentos
                            :contrato="contrato"
                            :requisicao="requisicaoDetalhe"
                            :dataServico="dataServico"
                            @obter-requisicao-atualizada="obterRequisicao()"
                        ></requisicao-comprometimentos>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <!-- <router-view
            v-if="requisicao"
            :requisicao="requisicao"
            :dataServico="dataServico"
        ></router-view> -->
    </div>
</template>

<script>
import RequisicaoItens from './RequisicaoItens'
import RequisicaoComprometimentos from '../comprometimentos/RequisicaoComprometimentos'

export default {
    components: {
        RequisicaoItens,
        RequisicaoComprometimentos
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        },

        requisicoes: {
            type: Array,
            default: () => []
        },

        dataServico: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            erros: [],
            requisicaoDetalhe: {}
        }
    },

    methods: {
        voltar() {
            if (
                this.$route.name == 'FornecedoresContratos_RequisicaoDetalhar'
            ) {
                this.$router.push({
                    name: 'FornecedoresContratos_Comprometimentos'
                })
            } else {
                this.$router.push({
                    name: 'FornecedorContratos_Comprometimentos'
                })
            }
        },

        obterRequisicao() {
            this.$store.dispatch('addRequest')
            let promisse
            if (
                this.$route.name === 'FornecedoresContratos_RequisicaoDetalhar'
            ) {
                promisse = this.dataServico.obterRequisicao(
                    this.$route.params.fornecedorId,
                    this.$route.params.codContrato,
                    this.$route.params.idRequisicao
                )
            } else {
                promisse = this.dataServico.obterRequisicao(
                    this.$route.params.codContrato,
                    this.$route.params.idRequisicao
                )
            }
            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.requisicaoDetalhe = response.data
                    } else {
                        this.erros = ['Erro ao obter requisição']
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }

        // obterFornecedoresServicos() {
        //     return FornecedoresServicos
        // },
        // atualizarFornecedor(dado) {
        //     this.ultimoAcesso = dado ? this.$moment(dado) : null
        // }
    },

    computed: {
        requisicao() {
            return this.requisicoes.find(
                c => c.idRequisicao === this.$route.params.idRequisicao
            )
        }

        // isRotaContratosDetalhar() {
        //     return (
        //         this.$route.name === 'FornecedoresContratos_Detalhar' ||
        //         this.$route.name === 'FornecedorContratos_Detalhar'
        //     )
        // },

        // mostrarDashboardContrato() {
        //     return this.isRotaContratosDetalhar
        // },

        // mostrarBtnVoltar() {
        //     return this.isRotaContratosDetalhar
        // }
    },

    created() {
        this.obterRequisicao()
    },

    watch: {}
}
</script>
